import { useRef } from "react";
function getStringForKey(key) {
  return key.length === 1 || !/^[A-Z]/i.test(key) ? key : "";
}
function useTypeSelect(options) {
  const { keyboardDelegate, selectionManager, onTypeSelect } = options;
  const state = useRef({
    search: "",
    timeout: null
  }).current;
  const onKeyDown = (e) => {
    const character = getStringForKey(e.key);
    if (!character || e.ctrlKey || e.metaKey) return;
    if (state.search && character === " ") e.preventDefault();
    state.search += character;
    const key = keyboardDelegate.getKeyForSearch(state.search);
    if (key !== null) {
      selectionManager.setFocusedKey(key);
      onTypeSelect == null ? void 0 : onTypeSelect(key);
    }
    clearTimeout(state.timeout);
    state.timeout = setTimeout(() => {
      state.search = "";
    }, 500);
  };
  return { typeSelectProps: { onKeyDown } };
}
export {
  useTypeSelect
};
//# sourceMappingURL=useTypeSelect.es.js.map
